module.exports = __webpack_public_path__ + "static/media/bg6.7b2adcf1.jpeg";